import React, { Fragment, useState, useContext, useEffect } from 'react';
import { CartContext } from 'components/cart';
import classNames from 'lib/classNames';



const Badges = ({badges}) => {

    return(
        <div dangerouslySetInnerHTML={{
            __html: badges.value ||""
          }}>

        </div>
    )
}

export default Badges